import { createContext, useContext } from 'react';

export const NestedModalContext = createContext<{
  isNestedModalOpen: boolean;
  setNestedModalOpen: (isOpen: boolean) => void;
}>({
  isNestedModalOpen: false,
  setNestedModalOpen: () => {},
});

export const useNestedModalContext = () => useContext(NestedModalContext);
